import { useCallback, useEffect, useState } from 'react';
import { FormCondition, Condition } from '@urbanx/agx.campaigns.client';
import { AgxButton } from '@urbanx/agx.ui-components2';
import { NewFormConditionModal } from './NewFormConditionModal';

interface AddBuildingAndPestProps {
  id: string;
  onConfirm: (buildingAndPest: FormCondition) => void;
}

export function AddBuildingAndPest({ id, onConfirm }: AddBuildingAndPestProps) {
  const [validate, setValidate] = useState(false);
  const [showAddBuildingPestModal, setShowAddBuildingPestModal] = useState(false);
  const [buildingAndPestCondition, setBuildingAndPestCondition] = useState<
    FormCondition | undefined
  >(undefined);
  const [errorMessage, setErrorMessage] = useState<string | undefined>(undefined);

  useEffect(() => {
    setValidate(false);
  }, [buildingAndPestCondition]);

  useEffect(() => {
    setErrorMessage(undefined);
    setBuildingAndPestCondition(undefined);
  }, [showAddBuildingPestModal]);

  const handleConfirmClick = useCallback(() => {
    setValidate(true);
    if (!buildingAndPestCondition || !buildingAndPestCondition.condition) {
      setErrorMessage('Select a condition');
      return;
    } else if (
      buildingAndPestCondition.condition === Condition.OnSpecificDate &&
      !buildingAndPestCondition.referenceDate
    ) {
      setErrorMessage('Select a date');
      return;
    } else if (
      buildingAndPestCondition.condition === Condition.NdaysFromDate &&
      !buildingAndPestCondition.daysFromDate
    ) {
      setErrorMessage('Enter number of days');
      return;
    } else if (
      buildingAndPestCondition.condition === Condition.UponSatisfactionOfSpecialCondition &&
      !buildingAndPestCondition.specialConditionId
    ) {
      setErrorMessage('Enter special condition clause');
      return;
    }

    onConfirm(buildingAndPestCondition);
    setShowAddBuildingPestModal(false);
  }, [buildingAndPestCondition, onConfirm]);

  return (
    <>
      <AgxButton
        id="add-building-pest"
        variant="hollow"
        text="Add Building & Pest"
        onClick={() => setShowAddBuildingPestModal(true)}
      />
      {showAddBuildingPestModal && (
        <NewFormConditionModal
          id={id}
          modalTitle="Add Building & Pest"
          formCondition={buildingAndPestCondition}
          onDateConditions={[Condition.OnSpecificDate]}
          fromDateConditions={[Condition.NdaysFromDate]}
          errorMessage={errorMessage}
          setFormCondition={setBuildingAndPestCondition}
          onConfirmClick={handleConfirmClick}
          openModal={setShowAddBuildingPestModal}
          validate={validate}
        />
      )}
    </>
  );
}
